var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.905,
    height: 14.905,
    viewBox: "0 0 14.905 14.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: "0.5px",
    d: "M5.943,5.125,9.855,1.24a.643.643,0,0,0,0-.914.653.653,0,0,0-.92,0L5.023,4.211,1.111.325a.653.653,0,0,0-.92,0,.643.643,0,0,0,0,.914L4.1,5.125.191,9.011a.643.643,0,0,0,0,.914.654.654,0,0,0,.92,0L5.023,6.04,8.935,9.925a.654.654,0,0,0,.92,0,.643.643,0,0,0,0-.914Zm0,0",
    transform: "translate(7.506 0.296) rotate(45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus2);
export default __webpack_public_path__ + "static/media/plus2.7750c334.svg";
export { ForwardRef as ReactComponent };